import React, { useState, useEffect } from "react";
import { editFont, getFont, createFont, getAllFiles } from "../../api/api";
import FontList from "../list/fontList";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import Select from "react-select";
import URLFontList from "../list/urlFontList";
import ToolTip from "../tooltip/tooltip";
// import { UserLang } from "../../store/userStore";

const Fonts = (props) => {
  const [list, setList] = useState([]);
  const [urlList, seturlList] = useState([]);
  const [disable, setDisable] = useState(true);
  // const lan = UserLang.useState((s) => s.lan);
  const [lan] = useState("ltr");

  const page = {
    selectedFont: "",
    items: list,
    urlItems: urlList,
  };
  const menuPic = [
    {
      value: "Default",
      label: "Default",
    },
    {
      value: "Elegant",
      label: "Elegant",
    },
    {
      value: "Classic",
      label: "Classic",
    },
    {
      value: "Modern",
      label: "Modern",
    },

    {
      value: "Fancy",
      label: "Fancy",
    },

    {
      value: "Booklet",
      label: "Booklet",
    },
    {
      value: "Knox",
      label: "Knox",
    },
    {
      value: "Custom URL Font",
      label: "Custom URL Font",
    },

    {
      value: "Custom Font",
      label: "Custom Font",
    },
  ];
  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);
  const [font, setFont] = useState(page);
  const [fontCount, setFontCount] = useState("");
  const [fontStatus, setFontStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [allFiles, setAllFiles] = useState([]);

  useEffect(() => {
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const pageid = props.match.params.id;
      const result = await getFont(pageid).then(
        (result) => {
          setFont(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setFontCount(obj.message);
          setFontStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const getFile = async () => {
      try {
        const appl = await getAllFiles(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.filekey,
          label: item.fileName,
          key: item.filekey,
          name: item.fileName,
          id: item._id,
        }));

        setAllFiles(opt);
      } catch (error) {}
    };

    /* eslint-disable no-unused-vars */
    elementDetail();
    getFile();

    /* eslint-disable no-unused-vars */
  }, [props.match.params.id]);

  const handleChange = (value, evt) => {
    const val = value.value;
    setDisable(false);
    setFont({
      ...font,
      [evt.name]: val,
    });
  };

  const draft = async (event) => {
    setLoading(true);
    event.preventDefault();
    setDisable(true);
    if (fontStatus === 404 || fontCount === "No Font Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createFont(font).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editFont(font).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const handleListChange = (edit) => {
    setDisable(false);
    const opt = edit.map((item) => ({
      itemid: item.value,
      itemRef: item.label,
      itemOrder: item.order,
      itemFile: item.file,
      itemFontType: item.fontType,
    }));
    setList(opt);
    /*eslint-disable no-useless-computed-key */

    setFont({
      ...font,
      ["items"]: opt,
    });

    /*eslint-disable no-useless-computed-key */
  };

  const handleURLListChange = (edit) => {
    setDisable(false);
    const opt = edit.map((item) => ({
      itemid: item.value,
      itemRef: item.label,
      itemOrder: item.order,
      itemFile: item.file,
      itemFontType: item.fontType,
    }));
    seturlList(opt);

    /*eslint-disable no-useless-computed-key */

    setFont({
      ...font,
      ["urlItems"]: opt,
    });

    /*eslint-disable no-useless-computed-key */
  };
  // const  greeting = ()=>{
  //   setDisable(false);
  //   handleListChange();
  // }
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Font Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={draft}>
                    <div className="row">
                      {lan === "rtl" && <div className="col-sm-6"></div>}
                      <div
                        className="col-sm-6"
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                      >
                        {/* text input */}
                        <label
                          className={
                            lan === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          {lan === "rtl" && (
                            <ToolTip
                              info={"Chose the Default font for the platform"}
                              place={lan === "rtl" ? "left" : "right"}
                            />
                          )}
                          &nbsp;Select Font&nbsp;
                          {!(lan === "rtl") && (
                            <ToolTip
                              info={"Chose the Default font for the platform"}
                              place={lan === "rtl" ? "left" : "right"}
                            />
                          )}
                        </label>
                        <Select
                          name="selectedFont"
                          className={
                            lan === "rtl"
                              ? "form-control inside-select float-right"
                              : "form-control inside-select float-left"
                          }
                          options={allIcon}
                          onChange={(value, event) =>
                            handleChange(value, event)
                          }
                        ></Select>

                        <div
                          className="row"
                          style={{
                            marginTop: "100px",
                            backgroundColor: "#f2f2f2",
                            marginLeft: "5px",
                          }}
                        >
                          <div
                            className="col-md-6"
                            style={{ marginTop: "20px", marginLeft: "2px" }}
                          >
                            <span>{font.selectedFont}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>
                    <div className="row mb-2 mt-2"></div>
                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={
                              "Add coustom font file from google fonts for the platform"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Custom Font&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={
                              "Add coustom font file from google fonts for the platform"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>
                    <FontList
                      data={allFiles}
                      dir={lan === "rtl" ? "rtl" : "ltr"}
                      url={props.match.params.id}
                      onChange={handleListChange}
                      name={font.selectedFont}
                      listData={font.items}
                      {...props}
                    ></FontList>

                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label>
                        {lan === "rtl" && (
                          <ToolTip
                            info={
                              "Add coustom font URL from google fonts for the platform"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Custom URL Font&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={
                              "Add coustom font URL from google fonts for the platform"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>

                    <div className="row mb-2 mt-2"></div>
                    <URLFontList
                      url={props.match.params.id}
                      dir={lan === "rtl" ? "rtl" : "ltr"}
                      listData={font.urlItems}
                      name={font.selectedFont}
                      onChange={handleURLListChange}
                      {...props}
                    ></URLFontList>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={
                              font.selectedFont === "Custom Font"
                                ? font.items.length === 2
                                  ? disable
                                  : true
                                : font.selectedFont === "Custom URL Font"
                                  ? font.urlItems.length === 2
                                    ? disable
                                    : true
                                  : disable
                            }
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Fonts;
